import React from 'react';

const LoginFooter = () => {
  const currentYear = new Date()?.getFullYear();

  return (
    <footer className="mt-8 md:mt-12 pt-6 md:pt-8 border-t border-border">
      <div className="text-center space-y-3 md:space-y-4">
        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 text-xs md:text-sm">
          <a
            href="/privacy-policy"
            className="text-muted-foreground hover:text-foreground transition-smooth font-caption focus-ring rounded px-1"
          >
            Privacy Policy
          </a>
          <span className="text-border">•</span>
          <a
            href="/terms-of-service"
            className="text-muted-foreground hover:text-foreground transition-smooth font-caption focus-ring rounded px-1"
          >
            Terms of Service
          </a>
        </div>

        <p className="text-xs text-muted-foreground font-caption">
          &copy; {currentYear} American Logics. All rights reserved.
        </p>

        <p className="text-xs text-muted-foreground/80 font-caption max-w-lg mx-auto px-4">
          This is a secure enterprise platform. Unauthorized access attempts are monitored and logged.
        </p>
      </div>
    </footer>
  );
};

export default LoginFooter;